import React, { useEffect, useState } from 'react';
import { Html } from '@react-three/drei';
import { useMediaXRSession } from '../hooks/useMediaXRSession';
import ScreenProp from './ScreenProp';
import { useWorldStore } from '../stores/worldStore';
import { Text } from '@react-three/drei';
import { normalizePanelUrl } from '../utils/panelUrl';
import './MediaPanels.css';

interface BrowserPropProps {
  position: [number, number, number]; scale: number; rotation: [number, number, number];
  isSelected?: boolean; url: string; width?: number; height?: number; editing?: boolean;
}
export default function BrowserProp({ position, scale, rotation, isSelected, url, width = 1024, height = 768, editing = false }: BrowserPropProps) {
  const [interacting, setInteracting] = useState(false);
  const [reload, setReload] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const inVR = !!useMediaXRSession();
  const stream = useWorldStore(s => s.activeScreenShare);
  useEffect(() => { setInteracting(false); }, [url, isSelected]);
  useEffect(() => { setLoaded(false); }, [url]);
  let safeUrl = '';
  try { safeUrl = normalizePanelUrl(url); } catch { /* Invalid legacy asset: show a placeholder. */ }
  const height3d = 4 * height / width;
  if (inVR) return <group position={position} rotation={rotation} scale={scale}>
    <ScreenProp position={[0, 0, 0]} rotation={[0, 0, 0]} scale={1} screenType="screen-share" streamData={stream} />
    {stream && <Text position={[0, 1.35, .03]} fontSize={.1}>Room screen share</Text>}
    {!stream && <Text position={[0, -.7, .03]} fontSize={.1} maxWidth={3.6} textAlign="center">Share a browser tab from desktop to show it here</Text>}
  </group>;
  return <group position={position} rotation={rotation} scale={scale}>
    <mesh position={[0, 0, -0.08]}><boxGeometry args={[4.16, height3d + 0.16, 0.12]} /><meshStandardMaterial color={isSelected ? '#00a99d' : '#242b32'} /></mesh>
      <Html transform position={[0, 0, 0.02]} distanceFactor={1600 / width} zIndexRange={[20, 0]} style={{ width, height, opacity: editing && isSelected && !interacting ? 0.35 : 1, pointerEvents: editing && !interacting ? 'none' : 'auto' }}>
        <div className="browser-panel" onPointerDown={e => e.stopPropagation()} onClick={e => e.stopPropagation()}>
          <div className="browser-panel-header">
            <span title={safeUrl}>{safeUrl || 'Choose a website using Change URL'}</span>
            <button onClick={() => { setLoaded(false); setReload(n => n + 1); }}>Reload</button>
            {safeUrl && <a href={safeUrl} target="_blank" rel="noopener noreferrer">Open tab</a>}
            {editing && <button onClick={() => setInteracting(value => !value)}>{interacting ? 'Done browsing' : 'Interact'}</button>}
          </div>
          <div className="browser-panel-body">
            {safeUrl && <iframe key={`${safeUrl}-${reload}`} src={safeUrl} title="Browser panel" onLoad={() => setLoaded(true)} sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-presentation" allow="fullscreen; autoplay; encrypted-media" allowFullScreen />}
            {editing && !interacting && <div className="browser-panel-shield">Use Interact to browse · drag the handles to move</div>}
          </div>
          <div className="browser-panel-help">{!loaded ? 'Loading page… ' : ''}Page blank or blocked? Open it in a tab and use Share Screen. Browsing is independent for each viewer.</div>
        </div>
      </Html>
  </group>;
}
